import { render, staticRenderFns } from "./LocalSignIn.vue?vue&type=template&id=52abf98b"
import script from "./LocalSignIn.vue?vue&type=script&lang=js"
export * from "./LocalSignIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports